import Lenis from "lenis";

export default () => {
  if (globalThis.self !== globalThis.top) {
    return;
  }

  const lenis = new Lenis({
    autoRaf: true,
  });

  lenis.start();
};
